import { useQuery } from "react-query";
import { getAgencyFromAgencyMapping } from "../../../../actions/CarrierAgreementMgmt/Agreements";

export const useAgencyFromAgencyMapping = () => {
  return useQuery("GetAgencyFromAgencyMapping", getAgencyFromAgencyMapping, {
    refetchOnWindowFocus: false,
  });
};
